import React from "react"

import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "gatsby"

import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import "swiper/components/scrollbar/scrollbar.scss"

// Import Swiper styles
import "swiper/swiper.scss"

import bg1 from "../../images/BG1.png"
import bg2 from "../../images/BG2.png"
import bg4 from "../../images/BG4.png"
import logo from "../../images/fluo-pentagram.png"

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay])

const SwiperTest = () => {
  return (
    <div className="position-relative overflow-hidden">
      <div style={{ position: "relative", zIndex: "1" }}>
        <div className="hero-swiper-responsive">
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            speed={700}
            loop={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: "#heroNext",
              prevEl: "#heroPrev",
            }}
          >
            <SwiperSlide
              className="hero-slide-wrapper"
              style={{ backgroundImage: `url(${bg1})` }}
            >
              <div className="hero-slide hero-default">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 mx-auto">
                      <div className="text-center align-items-center">
                        <div className="hero-content">
                          <img
                            className="img-fluid"
                            src={logo}
                            alt="Fluo Pentagram Logo"
                          />
                          <h1 className="hero-title text-uppercase pt-0">
                            Feel Alive
                          </h1>
                          <div className="d-flex align-items-center justify-content-center">
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/shop"
                            >
                              Shop
                              <span className="d-block">show support</span>
                            </Link>
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/inside-fluo"
                            >
                              Discover
                              <span className="d-block">Who We Are</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="hero-slide-wrapper"
              style={{ backgroundImage: `url(${bg2})` }}
            >
              <div className="hero-slide">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 mx-auto">
                      <div className="text-center align-items-center">
                        <div className="hero-content">
                          <h2 className="hero-title text-uppercase">
                            ECHO GREETINGS
                          </h2>
                          <div className="d-flex align-items-center justify-content-center">
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/shop"
                            >
                              Shop
                              <span className="d-block">show support</span>
                            </Link>
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/inside-fluo"
                            >
                              Discover
                              <span className="d-block">Who We Are</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className="hero-slide-wrapper"
              style={{ backgroundImage: `url(${bg4})` }}
            >
              <div className="hero-slide">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 mx-auto">
                      <div className="text-center align-items-center">
                        <div className="hero-content">
                          <h2 className="hero-title text-uppercase">
                            water bottles
                          </h2>
                          <div className="d-flex align-items-center justify-content-center">
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/shop"
                            >
                              Shop
                              <span className="d-block">show support</span>
                            </Link>
                            <Link
                              className="hero-cta mt-3 mx-2 text-uppercase"
                              to="/inside-fluo"
                            >
                              Discover
                              <span className="d-block">Who We Are</span>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      <div className="position-relative" style={{ zIndex: 3 }}>
        <div className="bottom-wave" />
      </div>
      <div className="wave-buttons-wrapper">
        <div className="swiper-button-prev" id="heroPrev">
          <svg
            className="waves left-arrow"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shape-rendering="auto"
          >
            {" "}
            <defs>
              {" "}
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />{" "}
            </defs>{" "}
            <g className="parallax">
              {" "}
              <use xlinkHref="#gentle-wave" x="48" y="8" fill="#35c2ff" />{" "}
            </g>{" "}
          </svg>
        </div>
        <div className="swiper-button-next" id="heroNext">
          <svg
            className="waves right-arrow"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
          >
            {" "}
            <defs>
              {" "}
              <path
                id="gentle-wave"
                d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
              />{" "}
            </defs>{" "}
            <g class="parallax">
              {" "}
              <use xlinkHref="#gentle-wave" x="8" y="7" fill="#35c2ff" />{" "}
            </g>{" "}
          </svg>
        </div>
      </div>
    </div>
  )
}

export default SwiperTest
